import { render, staticRenderFns } from "./SiteLayout.vue?vue&type=template&id=64fcb138&scoped=true"
var script = {}
import style0 from "./SiteLayout.vue?vue&type=style&index=0&id=64fcb138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.106.2_postcss@8.5.15___lodash@4.18.1_pre_97827144a0f6aa48df0612a675550f8c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fcb138",
  null
  
)

export default component.exports